import { useEffect, useRef, useState } from "react";
import ZONES_DATA from "./zoneData";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMap } from '@fortawesome/free-solid-svg-icons';


// ─── CONFIG ──────────────────────────────────────────────────────────────────
const GOOGLE_MAPS_API_KEY = "AIzaSyBRT-gAls8JiRt1UFJaml4oN9Mmev41LKI";
const MAP_CENTER = { lat: 17.385, lng: 78.4867 }; // Hyderabad
const MAP_ZOOM = 11;
// ─────────────────────────────────────────────────────────────────────────────

let googleMapsPromise = null;
function loadGoogleMaps(apiKey) {
  if (window.google?.maps) return Promise.resolve();
  if (googleMapsPromise) return googleMapsPromise;

  // Surface the real Google auth failure (shows the exact error type)
  window.gm_authFailure = () => {
    console.error(
      "[Google Maps] Authentication failed. Check: (1) billing enabled, " +
      "(2) Maps JavaScript API enabled, (3) API key restrictions allow this origin."
    );
  };

  googleMapsPromise = new Promise((resolve, reject) => {
    const existing = document.querySelector('script[data-gmaps="1"]');
    if (existing) {
      existing.addEventListener("load", resolve);
      existing.addEventListener("error", reject);
      return;
    }
    const script = document.createElement("script");
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&loading=async&v=weekly`;
    script.async = true;
    script.defer = true;
    script.dataset.gmaps = "1";
    script.onload = resolve;
    script.onerror = reject;
    document.head.appendChild(script);
  });
  return googleMapsPromise;
}

export default function KMLmap() {
  const mapRef = useRef(null);
  const polygonsRef = useRef([]);
  const [activeZone, setActiveZone] = useState(null);

  useEffect(() => {
    let cancelled = false;

    async function initMap() {
      await loadGoogleMaps(GOOGLE_MAPS_API_KEY);
      if (cancelled || !mapRef.current) return;

      const map = new window.google.maps.Map(mapRef.current, {
        center: MAP_CENTER,
        zoom: MAP_ZOOM,
        mapTypeId: "roadmap",
        streetViewControl: false,
        fullscreenControl: true,
      });

      const infoWindow = new window.google.maps.InfoWindow();

      // Draw each zone
      ZONES_DATA.forEach((zone) => {
        zone.polygons.forEach((coords) => {
          const polygon = new window.google.maps.Polygon({
            paths: coords,
            map: map,
            strokeColor: zone.color,
            strokeWeight: 2,
            fillColor: zone.color,
            fillOpacity: 0.25,
          });

          // Highlight on hover
          polygon.addListener("mouseover", () => {
            polygon.setOptions({ fillOpacity: 0.5 });
            setActiveZone(zone.name);
          });
          polygon.addListener("mouseout", () => {
            polygon.setOptions({ fillOpacity: 0.25 });
            setActiveZone(null);
          });

          // Show info on click
          polygon.addListener("click", (e) => {
            infoWindow.setContent(`
              <div style="font-family:Segoe UI,sans-serif; padding:2px 2px">
                <strong style="color:${zone.color}">${zone.name}</strong>
              </div>
            `);
            infoWindow.setPosition(e.latLng);
            infoWindow.open(map);
          });

          polygonsRef.current.push(polygon);
        });
      });
    }

    initMap();

    return () => {
      cancelled = true;
      polygonsRef.current.forEach((p) => {
        window.google.maps.event.clearInstanceListeners(p);
        p.setMap(null);
      });
      polygonsRef.current = [];
    };
  }, []);

  return (
    <div style={styles.wrapper}>

      {/* Header */}
      <div style={styles.header}>
        <h2 style={styles.title}><FontAwesomeIcon icon={faMap} style={{ color: 'gray', marginRight: '8px' }} /> Hyderabad — 6 Zones</h2>
        <span style={{ ...styles.activeLabel, visibility: activeZone ? "visible" : "hidden" }}>
          {activeZone || " "}
        </span>
      </div>

      {/* Map */}
      <div ref={mapRef} style={styles.map} />

      {/* Legend */}
      <div style={styles.legend}>
        {ZONES_DATA.map((zone) => (
          <div key={zone.name} style={styles.legendItem}>
            <span style={{ ...styles.dot, background: zone.color }} />
            <span style={styles.legendText}>{zone.name}</span>
          </div>
        ))}
      </div>

    </div>
  );
}

const styles = {
  wrapper: {
    display: "flex",
    flexDirection: "column",
    height: "80vh",
    fontFamily: "Segoe UI, sans-serif",
    borderRadius: "12px",
   
  },
  header: {
    display: "flex",
    alignItems: "center",
    gap: "16px",
    padding: "12px 20px",
    background: "#e8e8e8",
    color: "black",
    height: "50px",
    boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
  },
  title: { margin: 0, fontSize: "18px", fontWeight: 600 },
  activeLabel: {
    background: "rgba(255,255,255,0.25)",
    padding: "4px 12px",
    borderRadius: "20px",
    fontSize: "13px",
    fontWeight: 500,
  },
  map: { flex: 1, width: "100%" },
  legend: {
    display: "flex",
    flexWrap: "wrap",
    gap: "12px",
    padding: "10px 20px",
    background: "#fff",
    borderTop: "1px solid #e0e0e0",
    justifyContent: "center",
  },
  legendItem: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
  },
  dot: {
    width: "12px",
    height: "12px",
    borderRadius: "50%",
    display: "inline-block",
  },
  legendText: { fontSize: "12px", color: "#444" },
};
